export default __webpack_public_path__ + "static/media/rotor-top.9ca9f80c.svg";